import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  opacity: PropTypes.number,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.number,
};

const defaultProps = {
  color: '#0D0D0D',
  height: 14,
  opacity: 1.0,
  width: 14,
  strokeWidth: 1.8,
};

function CheckIcon({ color, height, opacity, strokeWidth, width }) {
  return (
    <svg aria-label="check icon" height={height} role="img" viewBox="0 0 14 14" width={width}>
      <polyline
        fill="none"
        opacity={opacity}
        points="2.293 6.73 5.842 10.052 11.707 3.948"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

CheckIcon.propTypes = propTypes;
CheckIcon.defaultProps = defaultProps;

export default CheckIcon;
